import * as React from 'react';

const Intro: React.StatelessComponent<{}> = () => {
  return (<div>We're cooking. Website should be fully up by tomorrow</div>);
};

export default Intro;
